import React from 'react';

export const NoDataErrorPage = (props) => {
    const {error} = props;

    return (
        <div className="page-internal-error">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-md-4 col-md-offset-2">
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <img src="images/ITN-logo-grey.png" alt="" className="logo"/>
                        <h5 className="h5">There has been an error loading your <br/>profile</h5>
                        <p className="p-tag">Error Code: <b>{error}</b></p>
                        <p className="p-tag">Please <b>hard refresh</b> (press "Ctrl"&nbsp;+&nbsp;"R" or "Ctrl"&nbsp;+&nbsp;"F5" on Windows, "Cmd"&nbsp;+&nbsp;"Shift"&nbsp;+&nbsp;"R" on Mac) or contact Customer Care on 0161&nbsp;714&nbsp;41&nbsp;79 quiting error code {error}.</p>
                        <ul className="buttons-left">
                            <li>
                                <button className="btn btn-primary" type="button"
                                        onClick={ () => location.reload() } >
                                    <span className="label">Reload this page</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/NoDataErrorPage.js